/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Reset_ViewInputs */

const cs_workflow_reset_view = /** @type {(inputs: Workflow_Reset_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit pohled`)
};

const en_workflow_reset_view = /** @type {(inputs: Workflow_Reset_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset view`)
};

/**
* | output |
* | --- |
* | "Reset view" |
*
* @param {Workflow_Reset_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_reset_view = /** @type {((inputs?: Workflow_Reset_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Reset_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_reset_view(inputs)
	return cs_workflow_reset_view(inputs)
});